import type { ReactNode } from 'react';

interface LegalDocProps {
  title: string;
  effectiveFrom: string;
  children: ReactNode;
}

export function LegalDoc({ title, effectiveFrom, children }: LegalDocProps) {
  return (
    <div className="mx-auto max-w-3xl px-6 lg:px-12 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold text-eol-white">{title}</h1>
      <p className="mt-2 text-sm text-eol-desc">Действует с {effectiveFrom}</p>
      <article className="mt-8 space-y-6 text-eol-desc leading-relaxed [&_h2]:text-eol-white [&_h2]:font-bold [&_h2]:text-xl [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:text-eol-white [&_h3]:font-semibold [&_h3]:text-lg [&_h3]:mt-6 [&_h3]:mb-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_p]:leading-relaxed [&_strong]:text-eol-white">
        {children}
      </article>
    </div>
  );
}
